/** Constantes da tabela compacta da Torre (9 colunas). */

export const COMPACT_COLUMN_KEYS = [
    'placa',
    'rota',
    'prevSaida',
    'prevCheg',
    'realSaida',
    'realCheg',
    'prazo',
    'status',
    'acoes',
] as const;

export type CompactColumnKey = typeof COMPACT_COLUMN_KEYS[number];

/** Larguras priorizando Placa, Status e Prazo; rota fica curta (tooltip). */
export const COMPACT_COLUMN_WIDTHS: string[] = [
    '96px',  // placa
    '88px',  // rota
    '78px',  // prevSaida
    '78px',  // prevCheg
    '78px',  // realSaida
    '78px',  // realCheg
    '100px', // prazo
    '120px', // status
    '52px',  // acoes
];

export const COMPACT_COLUMN_COUNT = COMPACT_COLUMN_KEYS.length;

export const COMPACT_PAGE_SIZE = 10;
export const COMPACT_TABLE_MIN_WIDTH = 768;
